import React from 'react';
import './navitem.css';

const NavItem = (props) => {
    return ( 
        <>
        <li>
            <a className='navitem body' href={props.id}>{props.navitem}</a>
        </li>
        </>
     );
}
 
export default NavItem;